import { render, staticRenderFns } from "./BookKeepingTop.vue?vue&type=template&id=78b99202&"
import script from "./BookKeepingTop.vue?vue&type=script&lang=ts&"
export * from "./BookKeepingTop.vue?vue&type=script&lang=ts&"
import style0 from "./BookKeepingTop.vue?vue&type=style&index=0&id=78b99202&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports